import { getAuthToken, refreshAuthToken } from "auth/authToken";
import { MainContent } from "components/Layout/components/Content";
import { Header, HeaderProps } from "components/Layout/components/Header/Header";
import { MasterLayout } from "components/Layout/components/MasterLayout";
import { SideBar } from "components/Layout/components/SideBar";
import { SupportedApps } from "config/config";
import { useApp } from "hooks/useApp";
import { useEnsureAuthenticated } from "hooks/useEnsureAuthenticated";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const TmsAppEnvironmentProvider = React.lazy(() => import("tmsapp/AppEnvironmentProvider"));
const TmsContent = React.lazy(() => import("tmsapp/TmsContent"));
const TmsMenu = React.lazy(() => import("tmsapp/Menu"));

type TmsAppContainerProps = {
    unauthenticatedHandler: (back: string) => void;
    headerProps: HeaderProps;
};

export const TmsAppContainer = ({ unauthenticatedHandler, headerProps }: TmsAppContainerProps) => {
    const navigate = useNavigate();
    const authToken = getAuthToken();
    const ensureAuthenticated = useEnsureAuthenticated();

    const tmsApp = useApp(SupportedApps.tms);

    const hasRole = (_role: string) => {
        return true;
    };

    useEffect(() => {
        refreshAuthToken().catch((e) => {
            // eslint-disable-next-line no-console
            console.error("Auth error", e);
            navigate("/auth");
        });
    }, [navigate]);

    return (
        tmsApp.isLoaded() && (
            <TmsAppEnvironmentProvider
                authToken={authToken}
                containerVersion={APP_INFO.VERSION}
                configuration={tmsApp.configuration}
                extraTerminalActions={[]}
                ensureAuthenticated={ensureAuthenticated}
                hasRole={hasRole}
                unauthenticatedHandler={unauthenticatedHandler}
            >
                <MasterLayout>
                    <Header appTitle={headerProps.appTitle} username={headerProps.username} userProfile={headerProps.userProfile} />
                    <SideBar>
                        <TmsMenu />
                    </SideBar>
                    <MainContent id="pageContent">
                        <TmsContent />
                    </MainContent>
                </MasterLayout>
            </TmsAppEnvironmentProvider>
        )
    );
};
